import i18next from 'i18next';

import { duplicateTemplate } from 'common/api/templates';
import showToast from 'common/utils/showToast';

import {
    DUPLICATE_TEMPLATE,
    DUPLICATE_TEMPLATE_SUCCESS,
    DUPLICATE_TEMPLATE_FAILURE,
} from '../actionTypes';
import { templatesActions } from '../reducer';

import filterTemplates from './filterTemplates';

export default (filterData, values) => (dispatch) => {
    dispatch(templatesActions[DUPLICATE_TEMPLATE]());
    const newValues = {
        title: `${i18next.t('Copy of')} ${values.title}`,
        template_id: values.id,
    };
    duplicateTemplate(newValues)
        .then((response) => {
            dispatch(
                templatesActions[DUPLICATE_TEMPLATE_SUCCESS](response.data),
            );
            dispatch(filterTemplates(filterData));
            showToast({
                body: i18next.t('Successfully duplicated'),
            });
        })
        .catch((error) =>
            dispatch(
                templatesActions[DUPLICATE_TEMPLATE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
